import { doc, getDoc } from "firebase/firestore";
import { db } from "../../firebase";

// Generic function to fetch configuration from new Firestore paths
async function getConfig(category) {
  try {
    const configDocRef = doc(db, "configs", `${category}Config`);
    const configDoc = await getDoc(configDocRef);
    if (configDoc.exists()) {
      const data = configDoc.data();
      const settingsKey = `${category}Settings`;

      // Flatten the settings if they exist in a nested object
      if (data[settingsKey]) {
        return { ...data, ...data[settingsKey] };
      }
      return data;
    } else {
      // Fallback to old path for backward compatibility
      const oldDocRef = doc(db, `${category}Config`, "configDetails");
      const oldDoc = await getDoc(oldDocRef);
      if (oldDoc.exists()) {
        return oldDoc.data();
      }
      throw new Error(`No config found for: ${category}`);
    }
  } catch (error) {
    console.error("Error fetching config:", error);
    throw error;
  }
}

async function getChatConfigs() {
  return getConfig("chat");
}

async function getImageConfigs() {
  return getConfig("image");
}

async function getSpeechConfigs() {
  return getConfig("speech");
}

async function getAgentConfigs() {
  return getConfig("agent");
}

export { getChatConfigs, getImageConfigs, getSpeechConfigs, getAgentConfigs };
